<template>
    <div>
        <div class="modal fade" id="confirmModal" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-black" id="confirmModalLabel">Confirm</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="loading"></button>
                    </div>
                    <div class="modal-body">
                        <div class="my-3 text-black text-center">
                            {{ text }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModal">Close</button>
                        <button type="button" class="btn btn-primary" @click="confirm">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
    name: 'ModalConfirm',
    emits: ['confirm', 'close'],
    props: {
        text: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        confirm() {
            this.$emit('confirm');
            this.closeModal();
        },
        closeModal() {
            const modalElement = document.getElementById('confirmModal');
            if (modalElement) {
                if (
                    document.activeElement &&
                    modalElement.contains(document.activeElement) &&
                    typeof document.activeElement.blur === 'function'
                ) {
                    document.activeElement.blur();
                }
                const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
                modal.hide();
            }
            this.$emit('close');
        }
    }
}
</script>
